import React, { useState, useRef, useEffect } from "react";
import { Empty, Button, Checkbox, Select, Input } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import "./resumeSearchTableSelectable.scss";
import { getFieldStyle } from "../../themes";
import useResumeDataBaseStore from "../../store/resumedatabasesearch.store";

export default function ResumeSearchTableSelectable({
  isClickable = false,
  titleList,
  data,
  isEditField = true,
  columnWidth = [50, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
}){ 
  const [frozenColumns, setFrozenColumns] = useState(1);
  const location = useLocation(); 
  const navigate = useNavigate();
  const { resumeDataBaseUpgradeResumes } = useResumeDataBaseStore();

  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const ResetCheckBox = () => {
    var checkBoxResetArray = data?.map((item) => {
      return {
        isSelected: false,
      };
    });
    setCheckBoxData(() => [...checkBoxResetArray]);
  };

  useEffect(() => {
    const checkBoxArray = data?.map((item) => {
      return {
        isSelected: false,
      };
    });
    setCheckBoxData(checkBoxArray);
  }, [data]);

  if (!data) {
    return <Empty style={{ margin: "60px" }} />;
  }

  function enableDbUpdate() {
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      console.log(
        "enableDbUpdate checkBoxArray",
        idx,
        checkBoxData[idx].selected
      );
      if (checkBoxData[idx].isSelected) {
        return true;
      }
    }
    return false;
  }
  const onCheckBoxChange = (e) => {
    if (e.target.checked) {
      checkBoxData[e.target.value].isSelected = true;
    } else {
      checkBoxData[e.target.value].isSelected = false;
    }
    if (enableDbUpdate() == true) {
      setUpdateAvailable(true);
    } else {
      setUpdateAvailable(false);
    }
    setCheckBoxData(() => [...checkBoxData]);
  };


  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const getUpdated = (rowIndex) => {
    return checkBoxData[rowIndex]?.isSelected;
  };


  const encodeJson = (updateType) =>{

    let encodedJsonValues ={};
    
    //get company details
    encodedJsonValues._id="Not used"
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    encodedJsonValues.qhoid= userData.qhoid;
    encodedJsonValues.accounttype= userData.account_type ;

    //now fill the parameters
    encodedJsonValues.resumelist =[];
    
    var num=0
    for(let idx = 0; idx < checkBoxData.length; idx++){
        //console.log("checkBoxData", idx,checkBoxData[idx])      
        if (checkBoxData[idx].isSelected && updateType =="UPGRADE_RESUMES_AND_INDEX" ) {
            encodedJsonValues.resumelist[num]={};
            encodedJsonValues.resumelist[num].qhrid =data[idx].resumeID;
            num++;
        }  
        if (checkBoxData[idx].isSelected && updateType =="RESUMES_INDEX" ) {
            encodedJsonValues.resumelist[num]={};
            encodedJsonValues.resumelist[num].qhrid =data[idx].resumeID;
            num++;
        }                
    }        
    //get the current date
    let newDate = getTimeNow()
    encodedJsonValues.updatetype = updateType
    encodedJsonValues.updatedby= userData.qhuid;
    encodedJsonValues.updatedbyname= userData.username;
    encodedJsonValues.updatedon    = newDate;
         
    return encodedJsonValues
}

const handleUpgrade = (value) => {
    var jasonValues= encodeJson("UPGRADE_RESUMES_AND_INDEX")
    console.log("Users Details Updating", jasonValues)
    resumeDataBaseUpgradeResumes({
        jasonValues
    });
    ResetCheckBox();
    setUpdateAvailable(false);
    setSelectAll(false);
}

  const handleSelectAll = () => {
    const tempCheckBoxData = [...checkBoxData];
    if (selectAll) {
      tempCheckBoxData.forEach((item) => {
        item.isSelected = false;
      });
      setCheckBoxData(tempCheckBoxData);
      setUpdateAvailable(false);
    } else {
      tempCheckBoxData.forEach((item) => {
        item.isSelected = true;
      });
      setCheckBoxData(tempCheckBoxData);
      setUpdateAvailable(true);
    }
    setSelectAll(!selectAll);
  };

  const getStickyStyle = (index, cellType) => {
    if (index >= frozenColumns) return {};

    // Calculate sum of widths of all previous columns to set the 'left' property
    const leftOffset = columnWidth
      .slice(0, index)
      .reduce((acc, curr) => acc + curr, 0);

    return {
      position: "sticky",
      left: `${leftOffset}px`,
      zIndex: 10,
      background: cellType === "title" ? "#99d2fd" : "#c0e4ff",
      boxShadow:
        index === frozenColumns - 1 ? "2px 0 5px -2px rgba(0,0,0,0.2)" : "none", // Adds a nice shadow line
    };
  };
  const gridTemplate = columnWidth.map((w) => `${w}px`).join(" ");

  const handleViewResume = (resumeID) => {
      navigate(`/resumeDataBase/${resumeID}`)
  };

  return (
    <div className="resumesearchtable-selectable-wrapper">
      <div
        className="freeze-control"
        style={{ marginBottom: "10px", position: "sticky", left: "0" }}
      >
        <span style={{ fontSize: "14px" }}>Freeze Columns: </span>
        <input
          type="number"
          min="0"
          max={titleList.length}
          value={frozenColumns}
          onChange={(e) => setFrozenColumns(parseInt(e.target.value))}
          style={{
            width: "50px",
            marginLeft: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        />
      </div> 
      <div className="rtable-selectable-btn-wrapper">
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleUpgrade}
        >
          UpGrade Or Index
        </Button>
     
      </div>           
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: gridTemplate,
        }}
      >
        {titleList.map((title,idx) =>
          title === "Select" ? (
            <div className="rtable-title" style={getStickyStyle(idx, "title")}>
              <Checkbox
                onChange={handleSelectAll}
                checked={selectAll}
              ></Checkbox>
            </div>
          ) : (
            <div className="rtable-title">{title}</div>
          )
        )}
      </div>
      {data?.map((table, rowIndex) => (
        <div
          key={table.id}
          className="rtable-info-wrapper"
          style={{
            gridTemplateColumns: gridTemplate,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div
              className="rtable-info"
              style={{
                ...getFieldStyle(tableInfo, table[tableInfo]),
                ...getStickyStyle(idx, "info"),
              }}
              onClick={() =>
                        tableInfo == "name"
                          ? handleViewResume(table.resumeID)
                          : ""
              }              
            >
              {isEditField ? (
                <div className="edit-field-wrapper">
                  <>
                    {tableInfo === "id" ? rowIndex + 1 : <></>}
                    {tableInfo === "select" ? (
                      <Checkbox
                        value={rowIndex}
                        onChange={onCheckBoxChange}
                        checked={getUpdated(rowIndex)}
                      ></Checkbox>
                    ) : (
                      <> </>
                    )} 
                    {tableInfo !== "id" &&  tableInfo !== "select"?
                    <> {table[tableInfo]}</>
                    :<> </>
                    }                                                                    
                  </>
                </div>
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
